import React from 'react';
// import { Helmet } from 'react-helmet';

// const isGatsbyDev = Array.from(document.getElementsByTagName('meta'))
//   .some(({ name, content }) => name === 'note' && content === 'environment=development');

export interface GatsbyRootProps {
  children: React.ReactNode;
}

/* eslint-disable global-require */
export const GatsbyRoot = ({ children }: GatsbyRootProps) => (
  // Gatsby pages get pre-rendered, so we need to disable JQuery UI on React elements.
  <div data-enhance="false">
    {/* {isGatsbyDev && ( */}
    {/*   <Helmet> */}
    {/*     <link href={require(':assets/stylesheets/static_pages/static_pages.scss')} rel="stylesheet" type="text/css" /> */}
    {/*   </Helmet> */}
    {/* )} */}
    {children}
  </div>
);
